module.exports = __webpack_public_path__ + "img/fantasy-flight-games.0e359b25.svg";